import Typography from '@componentsNew/Typography';
import { Tab, TabPanel, Tabs, TabsBody, TabsHeader } from '@material-tailwind/react';

export function OptiTabs({
  selecionado = '',
  setSelecionado = () => {},
  data = [{ label: 'Label', value: 'label', content: null }],
  className = null,
  classNameBody = null,
  indicatorProps = null,
}) {
  return (
    <Tabs value={selecionado}>
      {data.length > 1 && (
        <TabsHeader
          className={
            className ??
            'rounded-none p-0 border-b-[2px] border-solid border-text-secundary border-x-0 border-t-0 w-auto'
          }
          indicatorProps={{
            className:
              indicatorProps ??
              'border-b-[3px] border-x-0 border-t-0 rounded-none border-solid border-sucess-main shadow-none top-[-1px]',
          }}
        >
          {data.map(({ label, value }) => (
            <Tab
              key={value}
              value={value}
              className={
                classNameBody ??
                `h-auto m-0 text-text-secundary ${selecionado == value && 'text-sucess-main'}`
              }
              onClick={() => setSelecionado(value)}
            >
              <Typography component="body-tab">{label}</Typography>
            </Tab>
          ))}
        </TabsHeader>
      )}

      <TabsBody className="p-0">
        {data.map(({ value, content }) => (
          <TabPanel key={value} value={value} className="p-0">
            {content}
          </TabPanel>
        ))}
      </TabsBody>
    </Tabs>
  );
}
